































import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
import {translate} from '@/services/trans'
import ReferencesBauminatorMobile from "@/components/ReferencesBauminatorMobile.vue";
declare let bauminatorData:any;

@Component
export default class ReferencesBauminator extends Vue {
  @Prop() isMobileView!: boolean;
  @Prop() topPosition!: number;

  public c_x = 0
  public t_x = 0
  public textAnimationDelay = -15
  public destopHeight = 0
  public positionValue = ''
  public references = []

  mounted() {
    window.addEventListener('scroll', this.onScroll);
    window.addEventListener('resize', this.onScroll);

    if(bauminatorData && bauminatorData.references){
      this.references = bauminatorData.references;
    }
  }

  onScroll(e: any) {
    const element: any = document.getElementById('references')
    const elementTopPosition = element.getBoundingClientRect().top
    const elementInnerHeight = element.clientHeight
    this.c_x = (elementTopPosition / (elementInnerHeight / 100))*0.9
    this.t_x = 500 + (elementTopPosition / (elementInnerHeight) * -10 * 530)
    if(this.c_x < -73 && this.downAction){
      console.log(this.c_x, this.downAction)
      this.nextFrom('references', false)
      this.downAction = false
      this.upAction = true
    }
    if(this.c_x > 20 && this.upAction){
      console.log(this.c_x, this.downAction)
      this.nextFrom('references', true)
      this.downAction = true
      this.upAction = false
    }
  }


  upAction = false
  downAction = true

  trans(key: string) {
    return translate(key)
  }

  @Emit("next")
  nextFrom(name :string, isDown: boolean = false) {}

}
